module.exports = __webpack_public_path__ + "img/pic_review_failed.6930f315.png";